const initialState = {
  CBPRteID: '',
  Start: '',
  End: '',
  TmtType: '',
  Amount: '',
  DARSApprovedCountRteMn: '',
  DARSApprovedCountRteMx: '',
  UnitsPerDay: '',
  UnitsPerWeek: '',
  TotalUnits: '',
  TotalAmount: '',
  UtilizationReq: '',
  RateInactive: '',
  MonthlySettlement: '',
  Comment: '',
  newCbpRates: false,
};

export default initialState;
